import React from "react";
import { Link } from "react-router-dom";
import { Linkedin, Twitter, Facebook, Instagram, Mail, Phone, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS, SERVICES } from "../data/site";

export const Footer = () => {
  return (
    <footer className="bg-brand-blue text-white relative noise-overlay" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 relative z-10">
        <div>
          <div className="mb-5">
            <img
              src="/logo.png"
              alt="IDEAL ENTERPRISES"
              className="h-20 w-auto bg-white/90 px-4 py-2"
            />
          </div>
          <p className="text-white/70 text-sm leading-relaxed">
            Engineering safe and reliable City Gas Distribution infrastructure across India since 1998.
          </p>
          <div className="flex gap-3 mt-6">
            {[
              { Icon: Linkedin, href: "#", label: "linkedin" },
              { Icon: Twitter, href: "#", label: "twitter" },
              { Icon: Facebook, href: "#", label: "facebook" },
              { Icon: Instagram, href: "#", label: "instagram" },
            ].map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                aria-label={label}
                data-testid={`footer-social-${label}`}
                className="w-9 h-9 grid place-items-center border border-white/20 hover:border-brand-orange hover:text-brand-orange transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <p className="overline mb-4 text-white/80">Quick Links</p>
          <ul className="space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-white/75 hover:text-brand-orange"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-white/80">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.slice(0, 8).map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  className="text-sm text-white/75 hover:text-brand-orange"
                  data-testid={`footer-service-${s.slug}`}
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="overline mb-4 text-white/80">Contact</p>
          <ul className="space-y-3 text-sm text-white/80">
            <li className="flex items-start gap-2.5">
              <MapPin size={16} className="text-brand-orange mt-0.5 shrink-0" />
              <span>{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-2.5">
              <Phone size={16} className="text-brand-orange shrink-0" />
              <a href={`tel:${COMPANY.phone}`} className="hover:text-brand-orange">{COMPANY.phone}</a>
            </li>
            <li className="flex items-center gap-2.5">
              <Mail size={16} className="text-brand-orange shrink-0" />
              <a href={`mailto:${COMPANY.email}`} className="hover:text-brand-orange">{COMPANY.email}</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 relative z-10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/60">
          <p>© {new Date().getFullYear()} {COMPANY.name}. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
